import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ArrowLeft } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../../redux/store";
import { clearTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { getGlobalBackHandler } from "../../../hooks";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";

const MobileHeader: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { navigateBackToSource, getSourcePath } = useNavigationHistory();
    const { topNavNameTitle } = useSelector((state: RootState) => state.mobileLayout);

    // Do not render the header if the current location is /mobile-dashboard
    if (location.pathname === "/mobile-dashboard") {
        return null;
    }

    const handleBack = () => {
        const backFn = getGlobalBackHandler();
        if (backFn) {
            // Use custom back handler if available
            backFn();
            return;
        }

        // Handle special cases first
        if (
            location.pathname === "/m-manager-timesheet" ||
            location.pathname === "/m-manager-timeoff" ||
            location.pathname === "/m-timesheet" ||
            location.pathname === "/m-timeoff"
        ) {
            navigate("/mobile-dashboard");
            return;
        }

        // If no source path, navigate to a safe default based on the current route
        if (location.pathname.includes("/break-details") && !location.pathname.includes("-mgr-view")) {
            navigate("/m-timesheet");
        } else if (location.pathname.includes("/m-timecard-record-detail")) {
            navigate("/m-timesheet");
        } else {
            navigate("/mobile-dashboard");
        }

        // // Try to navigate to recorded source path
        // const sourcePath = getSourcePath();
        // if (sourcePath) {
        //     navigate(sourcePath);
        // } else {
        //     // If no source path, navigate to a safe default based on the current route
        //     if (location.pathname.includes("/break-details") && !location.pathname.includes("-mgr-view")) {
        //         navigate("/m-timesheet");
        //     } else if (location.pathname.includes("/m-timecard-record-detail")) {
        //         navigate("/m-timesheet");
        //     } else {
        //         navigate("/mobile-dashboard");
        //     }
        // }
    };

    return (
        <header className="bg-white static top-0 left-0 w-full">
            <div className="flex items-center justify-center px-4 pt-4 relative">
                {/* Back Button */}
                <button
                    onClick={handleBack}
                    aria-label="Back"
                    className="text-gray-700 hover:text-black absolute left-4"
                >
                    <ArrowLeft className="w-6 h-6" />
                </button>

                {/* Centered Title */}
                {topNavNameTitle && (
                    <div className="flex-1 flex justify-start">
                        <h1 className="text-lg font-semibold ml-8">{topNavNameTitle}</h1>
                    </div>
                )}
            </div>
        </header>
    );
};

export default MobileHeader;
